import React from "react";
import UsersTable from "../components/Tables/UsersTable";
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import UserModal from '../components/Modals/UserModal';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import TableTop from '../components/Tables/TableSiteTop';
import { loadUsers, deleteUser } from "../actions/userActions";
import compose from 'recompose/compose';
import { modalToggle } from '../actions/modalActions';
import { addUsersSearchCriteria } from '../actions/searchActions';


const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: 8,
    margin: 8
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
});

class UsersPage extends React.Component {
  componentDidMount() {
    const { loadUsers } = this.props;
    loadUsers();
  }


  state = {
    isModalOpen: false,
    // The modal is used for editing and creating.
    // Thus, the modal needs the information, which
    // functionality is to be used.
    useEditModal: false,
    // When clicking a table row, the row is hilighted and modal opened.
    // This property is used for removing the hilight when modal is closed.
    useSelectedRow: true,
    selectedUser: null,
    isDeleting: false
  }

  handleCreateModalOpen = () => {
    this.setState({ isModalOpen: true });
    this.props.modalToggle(true);
  };

  handleCreateModalClose = () => {
    this.setState({ isModalOpen: false, useEditModal: false, useSelectedRow: false, selectedUser: null });
    this.props.modalToggle(false);
  };

  handleEditClick = (user) => {
    this.props.modalToggle(true);
    this.setState({isModalOpen: true, useEditModal: true, useSelectedRow: true, selectedUser: user});
  }

  handleUserClick = (user) => {
    if (this.state.isDeleting ) {
      return;
    }
    this.props.modalToggle(true);
    this.setState({isModalOpen: true, useEditModal: true, useSelectedRow: true, selectedUser: user});
  }

  handleUserDelete = async (user) => {
    if (this.props.isDeleting ) {
      return;
    }
    this.setState({ useSelectedRow: true, selectedUser: user});
    let ans = window.confirm("Are you sure you want to delete this user?");
    if(ans) {
      await this.props.deleteUser(user);
    }
    this.setState({ useSelectedRow: false, selectedUser: null});
  }

  handleSearchFieldChange = (searchCriteria) => {
    this.props.addUsersSearchCriteria(searchCriteria);
  }

  render() {
    const {classes, users, role, searchFieldValues} = this.props;
    const { isModalOpen, useEditModal, useSelectedRow, selectedUser } = this.state;
    const { handleCreateModalOpen, handleCreateModalClose, handleUserDelete } = this;

    return (
      <div className={classes.root}>
        <TableTop role={role} handleModalOpen={handleCreateModalOpen} isButtonDisabled={(users.isLoading || users.hasErrored)} headlineText="Users"/>
        <Grid container spacing={24} alignItems="center">
      {users.hasFailed && (
        <Grid item xs={12}>
          <Typography>Error</Typography>
        </Grid>
      )}
      {users.isLoading && (
        <Grid item xs={12}>
          <CircularProgress className={classes.progress} size={50} />
        </Grid>
      )}
      {users.usersData != null && users.usersData.length > 0 && (
        <Grid item xs={12}>
          <UsersTable
            role={role}
            useSelectedRow={useSelectedRow}
            handleEditClick={this.handleEditClick}
            users={users.usersData}
            handleUserDelete={handleUserDelete}
            handleSearchFieldChange={this.handleSearchFieldChange}
            searchFieldValues={searchFieldValues.users}
          />
        </Grid>
      )}
      </Grid>
       <UserModal selectedUser={selectedUser} isEdit={useEditModal} isOpen={isModalOpen} handleClose={handleCreateModalClose}/>
    </div>

    )
  }
}

UsersPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    users: state.user.users,
    role: (state.oidc.user && state.oidc.user.profile) ? state.oidc.user.profile.identity_role : null,
    searchFieldValues: state.searchField
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadUsers: () => {
      dispatch(loadUsers())
    },
    modalToggle: (value) => {
      dispatch(modalToggle(value));
    },
    deleteUser: (user) => {
      dispatch(deleteUser(user))
    },
    addUsersSearchCriteria: (searchField) => {
      dispatch(addUsersSearchCriteria(searchField))
    }
  }
}

export default
  compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
  )(UsersPage);



// WEBPACK FOOTER //
// ./src/containers/UsersPage.js